package tta.destinigo.talktoastro.shared.platform

import kotlinx.browser.window

actual fun showToast(message: String) {
    window.alert(message)
}